FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="datepicker"]';
    var PARENT = '[data-parent="true"]';
    var EARLIEST_DATE = new Date('1/1/1753');
    var LATEST_DATE = new Date('12/31/9999');


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 80,
        value: '',

        format: 'DateFull',
        //  'DateFull': 03/18/2016    
        //  'DateVerbose': Fri, Mar 18, 2016  
        //  'DateShortMonthYear': Jan, 2016
        //  'DateDayMonthNum' : Fri, Mar 18
        months: 1,
        allownull: false,   //  datepicker can be empty on load
        allowclear: false,  // show the button to clear the datepicker
        mindate: null,      // null | data
        maxdate: null,      // null | data
        showleft: false,
        iswhite: false,   //     uses 'color-white'
        noedit: false
    };

    var selected = false;
    var clickedElement;

    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  get datepicker
    function getDatePicker(container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        //  bail
        if (list.length === 0) {
            return;
        }

        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());

            //  set elem data
            me.setControlItemOptions(elem, options);

            // if allow clear is enabled, allow null needs to be as well
            if (options.allowclear) {
                options.allownull = true;
            }
            if (options.noedit) {
                elem.prop('disabled', true);
            }

            //  set data
            elem.data(options);

            //  set value
            setDate(elem);
        });

        $(document).off('mousedown.DatepickerElementCheck').on('mousedown.DatepickerElementCheck', function (e) {
            clickedElement = e.target;
        });
    }


    //  set date
    function setDate(e) {
        var data = e.data();
        var value = e.val();

        if (!value || value === "") {
            if (data.allownull) {
                value = null;
            } else {
                value = new Date();
                e.val(value.getDateFriendly());
            }
        }

        if (value) {
            var theDate = new Date(value);

            if (!theDate.isValid() || theDate < EARLIEST_DATE || theDate > LATEST_DATE) {
                if (data.value && data.value.length > 0) {
                    theDate = new Date(data.value);
                } if (!theDate.isValid()) {
                    theDate = new Date();
                }
            }

            data.value = theDate.getDateFriendly();

            //  set date format
            setFormat(e);
        }


        if (!data.noedit) {
            var NAMESPACE = me.getUID('CTRL_');
            var parent = e.parent();

            var colorClass = data.iswhite ? 'color-white' : '';

            //  trigger
            if (data.showleft) {
                parent.find('.fa-calendar').remove();
                parent.find('input').before("<span class='" + colorClass + "' style='width: 0.9em;'><i id='" + NAMESPACE + "' class='fa fa-fw fa-calendar'></i></span>");
            } else {
                parent.find('.fa-calendar').remove();
                parent.find('input').after(" <span class='" + colorClass + "'><i id='" + NAMESPACE + "' class='fa fa-fw fa-calendar'></i></span>");
            }


            var btn = $('#' + NAMESPACE);

            btn.css({ cursor: 'pointer' });
            //  set picker
            if (!(e.hasClass('hasDatepicker') && e.hasClass('inline-block'))) { // If we're using the inline-block datepicker, we need to prevent the calendar from being drawn twice
                e.removeClass('hasDatepicker').datepicker({
                    numberOfMonths: data.months,
                    minDate: data.mindate,
                    maxDate: data.maxdate,
                    defaultDate: data.value,    //  sk added 5/11
                    buttonImageOnly: true,
                    buttonText: "",
                    showOn: "both",
                    onSelect: function (dT, ui) {
                        if (e.data('weekdaysonly') && ((new Date(dT)).getDay() === 0 || ((new Date(dT)).getDay() === 6))) {
                            dT = e.data('value');
                        }
                        if (e.data('mondaysonly') && (new Date(dT)).getDay() != 1 ) {
                            dT = e.data('value');
                        }
                        if (e.data('firstdayofmonth') && (new Date(dT)).getDate() != 1) {
                            dT = e.data('value');
                        }
                        e.datepicker('option', 'defaultDate', dT);
                        e.val(dT);
                        e.data('value', dT);
                        setFormat(e);
                        setCallback(e);
                        e.trigger('change');
                    },
                    beforeShowDay: function (date) {
                        if (e.data('weekdaysonly')) {
                            var dayOfWeek = date.getDay();
                            return [
                                !(dayOfWeek === 0 || dayOfWeek === 6),
                                "",
                                ""
                            ];
                        }
                        if (e.data('mondaysonly')) {
                            var dayOfWeek = date.getDay();
                            return [
                                (dayOfWeek === 1),
                                "",
                                ""
                            ];
                        }
                        if (e.data('firstdayofmonth')) {
                            var dayOfMonth = date.getDate();
                            return [
                                (dayOfMonth === 1),
                                "",
                                ""
                            ];
                        }
                        return [true, "", ""];
                    }
                }).on('blur', function (event) {
                    if (clickedElement.id !== 'ui-datepicker-div' && $(clickedElement).parents("#ui-datepicker-div").size() === 0) {
                        var theDate;
                        if (!e.val() || e.val() === "") {
                            if (e.data('allownull')) {
                                e.data('value', null);
                                setCallback(e);
                                return;
                            } else {
                                theDate = new Date(e.data('value'));
                            }
                        } else {
                            theDate = new Date(e.datepicker("getDate"));
                        }
                        var datestring = theDate.getDateFriendly();

                        if (datestring !== e.data('value')) {
                            var maxDate = e.datepicker("option", "maxDate");
                            var minDate = e.datepicker("option", "minDate");
                            if ((maxDate && theDate > new Date(maxDate)) || (minDate && theDate < new Date(minDate))) {
                                theDate = new Date(e.data('value'));
                            } else if (e.data('weekdaysonly') && (theDate.getDay() === 0 || theDate.getDay() === 6)) {
                                theDate = new Date(e.data('value'));
                            }

                            if (e.data('mondaysonly') && theDate.getDay() != 1) {
                                theDate = new Date(e.data('value'));
                            }
                            if (e.data('firstdayofmonth') && theDate.getDate() != 1) {
                                theDate = new Date(e.data('value'));
                            }

                            if (!theDate.isValid() || theDate < EARLIEST_DATE || theDate > LATEST_DATE) {
                                if (e.data('value') && e.data('value').length > 0) {
                                    theDate = new Date(e.data('value'));
                                } if (!theDate.isValid()) {
                                    theDate = new Date();
                                }
                            }


                            datestring = theDate.getDateFriendly();
                            e.datepicker('setDate', datestring);
                            e.datepicker('option', 'defaultDate', datestring);
                            e.data('value', datestring);
                            setFormat(e);
                            setCallback(e);
                        } else {
                            e.datepicker("setDate", theDate);
                            setFormat(e);
                        }
                    }
                });
            }

            btn.off('click');
            btn.on('click.dp', function () {
                e.datepicker('show');
            });

            if (data.allowclear) {
                parent.find('.fa-ban').remove();
                parent.find('.fa-calendar').after("<span style='width: 0.9em;'><i id='C_" + NAMESPACE + "' class='fa fa-fw fa-ban'></i></span>");

                var btnClear = $('#C_' + NAMESPACE);

                btnClear.css({ cursor: 'pointer' });

                btnClear.off('click');
                btnClear.on('click.dpc', function () {
                    e.data('value', null);
                    e.datepicker('setDate', null);
                    e.trigger('change');
                    setCallback(e);
                });
            }
        }
    }


    //  format
    function setFormat(e) {
        var data = e.data();
        var format = data.format.toLowerCase();
        var theDate = new Date(e.data('value'));
        var elem = data.element;

        switch (format) {
            case 'datefull': elem.val(theDate.getDateFriendly());
                break;
            case 'dateverbose': elem.val(theDate.getFullDateFriendly());
                break;
            case 'dateshortmonthyear': elem.val(theDate.getMonthDateFriendly());
                break;
            case 'datedaymonthnum': elem.val(theDate.getDayMonthNum());
                break;
            default: elem.val(theDate.getDateFriendly());
        }
    }


    //  set callback
    function setCallback(e) {
        var data = e.data();

        //  callback
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
    }





    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  set datepicker
    child.setDatePicker = function (container) {
        getDatePicker(container);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));